




















import { Component, Vue, Ref, Watch } from "vue-property-decorator";
import BaseDialogComponent from "@/components/common/BaseDialog.vue";

import { getMemberClientIds } from "@/data/repository/ClientRepository";
import ClientPanel, { findClientPanel } from "@/data/models/ClientPanel";
import { getAllAvailablePanelsOfMemberClients, getAvailablePanels } from "@/data/repository/ClientPanelRepository";
import { searchAnyHyDryDeviceAccess, viewHyDryDevicesOfMemberAccess } from "@/permissions/UserPermissions";
import { getEffectiveUser } from "@/utils/ViewAs";

@Component({
  components: {
    "base-dialog": BaseDialogComponent,
  },
})
export default class SearchForDeviceComponent extends Vue {
  serialNumber = "";

  @Watch("serialNumber")
  onSerialNumberChanged() {
    this.errorMessages = [];
  }

  resolve?: (value: string) => void = undefined;
  reject?: (reason: string) => void = undefined;

  clientPanels: ClientPanel[] = [];
  didLoadClientPanel = false;

  @Ref("baseDialog")
  baseDialogComponent!: BaseDialogComponent;

  errorMessages: string[] = [];

  /** The user whose view this shows: the chosen one while "Sicht auf" is active (ticket 2610052). */
  get activeUser() {
    return getEffectiveUser();
  }

  get isAllowedToSearchForAnyHyDryDevice() {
    return searchAnyHyDryDeviceAccess(this.activeUser)
  }

  get isAllowedToViewHyDryDevicesOfMemberClients() {
    const activeUser = getEffectiveUser();

    return viewHyDryDevicesOfMemberAccess(activeUser);
  }

  get memberClientIds() {
    return getMemberClientIds();
  }

  async show() {
    this.serialNumber = "";
    // The client's panels are loaded once per opening, so a device assigned meanwhile is found.
    this.didLoadClientPanel = false;

    this.baseDialogComponent.show({
      title: this.$t("searchIresDevice.title").toString(),
      positiveButtonText: this.$t("common.search").toString(),
      closeOnSave: false,
      persistent: true,
    });

    return new Promise<string>((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }

  async onSave() {
    if (this.isAllowedToSearchForAnyHyDryDevice) {
      this.resolve && this.resolve(this.serialNumber);
      return;
    }

    if (!this.didLoadClientPanel) {
      this.clientPanels = this.isAllowedToViewHyDryDevicesOfMemberClients
        ? await getAllAvailablePanelsOfMemberClients()
        : await getAvailablePanels();
      this.didLoadClientPanel = true;
    }

    const matchingClientPanel = findClientPanel(
      this.serialNumber,
      this.clientPanels
    );

    if (matchingClientPanel) {
      this.resolve && this.resolve(matchingClientPanel.serialNumber);
    } else {
      this.errorMessages = [
        this.$t("assignDevice.noMatchingDeviceFound").toString(),
      ];
    }
  }
}
